import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';
export function ThemeToggle({
  className
}: {
  className?: string;
}) {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const isDark = theme === 'dark';
  return <button type="button" onClick={toggleTheme} aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'} aria-pressed={isDark} className={`relative flex h-9 w-9 items-center justify-center border border-line text-ink transition-colors hover:border-brand hover:text-brand ${className ?? ''}`} data-cursor="hover" data-id="element-576" data-mp="3m4r0ncgrbaaa">
      <motion.span key={theme} initial={{
      opacity: 0,
      rotate: -40,
      scale: 0.7
    }} animate={{
      opacity: 1,
      rotate: 0,
      scale: 1
    }} transition={{
      duration: 0.35,
      ease: [0.16, 1, 0.3, 1]
    }} className="flex" data-id="element-577" data-mp="2ygzoc8v7ux90">
        {isDark ? <SunIcon className="h-4 w-4" data-id="element-578" data-mp="im7gkx88faqk" /> : <MoonIcon className="h-4 w-4" data-id="element-579" data-mp="iplk48smtpzl" />}
      </motion.span>
    </button>;
}